import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=457a71ee&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=457a71ee&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a71ee",
  null
  
)

export default component.exports